export const EDITOR_PLUGIN = 'EditorPlugin';
export const SANDBOX_PLUGIN = 'SandboxPlugin';
export const INTERACTIVE_MODE_PLUGIN = 'InteractiveModePlugin';